// hooks/usePaymentHistoryCxp.ts

import { useDispatch, useSelector } from "react-redux";

import {
  AppDispatch,
  RootState,
} from "../../../../store/store";

import useLoading
  from "../../../../hooks/useLoading";

import PaymentHistoryCxpService
  from "../services/paymentHistoryCxp.service";

import {
  clearPaymentHistory,
  setPaymentHistory,
  setPaymentHistoryError,
  setPaymentHistoryLoading,
  setSelectedPayableId,
} from "../store/paymentHistoryCxp.slice";

export const usePaymentHistoryCxp = () => {
  const dispatch: AppDispatch = useDispatch();

  const {
    showLoadingIndicator,
    hideLoadingIndicator,
  } = useLoading();

  const {
    history,
    loading,
    error,
    selectedPayableId,
  } = useSelector(
    (state: RootState) =>
      state.paymentHistoryCxp
  );

  /**
   * 📌 Obtener historial por ID
   */
  const fetchPaymentHistory = async (
    PayableId: number
  ) => {
    try {
      dispatch(
        setPaymentHistoryLoading(true)
      );

      dispatch(
        setSelectedPayableId(
          PayableId
        )
      );

      showLoadingIndicator();

      const data =
        await PaymentHistoryCxpService
          .getByPayableId(
            PayableId
          );

      dispatch(
        setPaymentHistory(data)
      );

      return data;
    } catch (err: any) {
      dispatch(
        setPaymentHistoryError(
          "Error al obtener historial de pagos"
        )
      );

      dispatch(
        clearPaymentHistory()
      );

      return null;
    } finally {
      dispatch(
        setPaymentHistoryLoading(false)
      );

      hideLoadingIndicator();
    }
  };

  /**
   * 🧹 limpieza manual
   */
  const clearHistory = () => {
    dispatch(
      clearPaymentHistory()
    );
  };

  return {
    // state
    history,
    loading,
    error,
    selectedPayableId,

    // actions
    fetchPaymentHistory,
    clearHistory,
  };
};